(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GlobalMessage', GlobalMessage);

    GlobalMessage.$inject = ['$resource', 'DateUtils'];

    function GlobalMessage($resource, DateUtils) {
        var resourceUrl = 'api/global-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'byCorporation': {url: 'api/global-messages/by-corporation/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
